export enum ContactType {
  mobile,
  phone = 'phone',
  email = 'email'
}

export enum ContactName {
  mobile = 'cell',
  home = 'home',
  work = 'work',
  email = 'email'
}

export type Contact = {
  id?: string;
  name: 'cell' | 'home' | 'work' | 'email';
  value: string;
  type: ContactType;
};
